<template>
  <isis-page-layout :title="$t('term.term_detail')">
    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title text-lg">{{ $t("term.term_info") }}</h4>
            </div>
          </md-card-header>

          <md-card-content>
            <validation-form @on-submit="editTerm" class="pt-2">
              <TermInfoForm
                :isEdit="true"
                :termData="termData"
                :serverValidations="serverValidations"
                :isReadOnly="isReadOnly"
                ref="termInformation"
              />

              <div class="text-center">
                <md-button class="md-raised mr-2" @click="goToPreviousPage">
                  {{ $t("common.cancel") }}
                </md-button>
                <md-button v-if="!isReadOnly" type="submit" class="md-success"
                  >{{ $t("common.update") }}
                </md-button>
              </div>

              <p class="ml-5 text-lg font-medium">
                {{ $t("term.list_of_terms_class") }}
              </p>
              <yv-index
                :path="path"
                :columns="columns"
                :hideAction="true"
                :disabledHeaderActions="true"
                :formatTableData="formatTableData"
              >
              </yv-index>
            </validation-form>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </isis-page-layout>
</template>

<script>
import { service_paths } from "@/constants/Services";
import { genErrMsgOj, hasHistory, Message } from "@/helpers/utils";
import IsisPageLayout from "../PageLayout";
import YvIndex from "@/components/Base/YvIndex.vue";
import { TEACHER_ASSIGNMENTS } from "@/constants";
import { term_router_names } from "@/routes/routes";
import { Term } from "@/constants/Permissions";
import TermInfoForm from "./TermInfoForm";

export default {
  components: { TermInfoForm, YvIndex, IsisPageLayout },
  data() {
    return {
      termId: this.$route.params.id,
      termData: {},
      serverValidations: {}
    };
  },
  computed: {
    path() {
      return `${service_paths.classes}/?term_id=${this.termId}&limit=99`;
    },
    columns() {
      return {
        name: this.$t("common.class"),
        teacher: this.$t("common.teacher"),
        course_name: this.$t("common.course"),
        amount_of_student: this.$t("term.amount_of_student"),
        status: this.$t("common.status"),
        schedule: this.$t("common.schedule")
      };
    },
    isReadOnly() {
      return !this.$can(Term.actions.edit, Term.subject);
    }
  },
  methods: {
    getDetail() {
      this.$axios
        .get(`${service_paths.terms}/${this.termId}`)
        .then(response => {
          this.termData = response.data;
        })
        .catch(error => {
          const errData = error.response?.data;
          if (errData) {
            Message.error(error.response?.data?.messages);
          }
        });
    },

    formatTableData(tableData) {
      tableData.forEach(item => {
        const primaryTeacher = item.teachers.find(
          teacher => teacher.assignment === TEACHER_ASSIGNMENTS.PRIMARY
        );
        item.teacher = primaryTeacher?.users?.user_no_sql?.full_name || "";
        item.course_name = item.course?.name;
        item.amount_of_student = item.students?.length;
        item.schedule = `<a href="/schedule?class_id=${item.id}&class_name=${item.name}" target="_blank">Schedule</a>`;
      });
      return tableData;
    },

    editTerm() {
      const formData = this.$refs.termInformation.formData;
      this.$axios
        .put(`${service_paths.terms}/${this.termId}`, formData)
        .then(() => {
          Message.success(this.$t("common.edit_success"));
          this.$router.push({ name: term_router_names.listPage });
        })
        .catch(error => {
          const errData = error.response?.data;
          if (errData) {
            this.serverValidations = genErrMsgOj(errData.messages);
          }
        });
    },
    goToPreviousPage() {
      hasHistory() ? this.$router.go(-1) : this.$router.push("/");
    }
  },
  created() {
    this.getDetail();
  }
};
</script>
